module.exports = __webpack_public_path__ + "img/dee53b2.jpg";